





























import { VehicleCompanyStoreHelper } from '../../core/mixins';
import { Component, Emit, Mixins, Prop, Vue, Watch } from 'vue-property-decorator';
import { Vehicle } from '../../core/models';
import { getIdsFromList } from '../../core/utils';
@Component({
    components: {
        
    }
})
export default class SelectedVehiclesChooser extends Mixins(
    VehicleCompanyStoreHelper
) {
   @Prop({default(){return []}}) customOptions: Array<Vehicle>;
   @Prop({default: null}) preselectValue: Vehicle | null;
   vehicleSelected: null | Vehicle = null;

    @Watch('vehicleSelected', { immediate: true })
    onSelectedVehicleChanged(value){
       this.onSelectedVehicle(value)
    }

    @Watch('preselectValue', { immediate: true })
    onPreselectVehicleChanged(value){
        this.vehicleSelected = value;
    }

    get selectorOptions(){
        return this.customOptions.length > 0 ? this.customOptions : this.vehiclesList;
    }

    get vehiclesList(){
        return this.$_getSelectedVehicles
    }

    @Emit()
    onSelectedVehicle(value: Vehicle) {
        return value
    }

    @Emit()
    onClearSelector() {
        this.vehicleSelected = null;
    }

    getAllVehiclesIdsCommaSeparated(){
        return getIdsFromList(this.vehiclesList);
    }

    mounted(){
        if(this.preselectValue){
            this.vehicleSelected = this.preselectValue;
        }
    }

    detroyed(){
        this.vehicleSelected = null;
    }
    
}
